const inkeep_ai_bot = {
    intro_message: "안녕하세요, 저는 Logto AI 입니다!\n\n저는 문서, 도움말 기사 및 기타 콘텐츠를 기반으로 훈련된 AI 도우미입니다.\n\n'Logto'에 대해 무엇이든 물어보세요.",
    chat_placeholder: 'Logto AI 에게 질문하여 단계별 안내를 받아보세요',
    disclaimer_label: 'Logto AI 면책 조항',
    disclaimer_tooltip: '응답은 AI 에 의해 생성되었으며 검증이 필요할 수 있습니다.',
    example_questions_label: '예시 질문',
    example_questions: [
        'Logto 설정 빠른 시작 가이드',
        '다중 테넌시 아키텍처 구성',
        '사용자 프로필을 어떻게 통합하나요?',
    ],
    stop: '중지',
    clear: '다시 시작',
    get_help: '도움 받기',
    copy_chat: '복사',
    ask_ai_label: 'AI 에게 물어보기',
    contact: '문의하기',
    discord: '디스코드',
};
export default Object.freeze(inkeep_ai_bot);
